import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';

import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';
import { ConsumerOfferDetailPage } from '../consumer-offer-detail/consumer-offer-detail';
import { ConsumerOfferManagerPage } from '../consumer-offer-manager/consumer-offer-manager';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { PurchaseHandlerProvider } from '../../providers/purchase-handler';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';
import { BaseListPage } from '../../providers/base-list-page';

@Component({
  selector: 'page-consumer-offer-list',
  templateUrl: 'consumer-offer-list.html',
})
export class ConsumerOfferListPage {
	business: any = {
		Id: 0,
		ImagePath: ""
	};

	businessId: any;
	filePath: any;
	businessFilePath: any;

	term: any="";
	categories: any = [];

	isPinned: any = false;

	hasOffers: any = true;

	offers: any = [];

	loadingMsg: any = "Loading...";
	
	requiresReload: boolean = false;
	isLoading: boolean = false;
	isRefreshing: boolean = false;
	isFetchingMore: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

	constructor(
		public utils: Utils,
		public navCtrl: NavController,
		public navParams: NavParams,
		public offerHandler: ConsumerOfferManagerHandler,
		public purchaseHandlerProvider: PurchaseHandlerProvider,
		private elRef: ElementRef,
		public globals: Globals,
		public platform: Platform) {

		this.filePath = this.globals.fileUrl;	
		this.isLoading = true;
	}

	ionViewWillEnter() {
		this.params.page = 1;
		
	    this.loadOffers(null);
	}	

	gotoBusiness(id){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			requiresReload: true,
			businessId: id
		});			
	}

  	doRefresh(refresher) {
		this.isRefreshing = true;

		this.params.page = 1;

		this.loadOffers(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 
		
		this.params.page++;
		this.isFetchingMore = true;

		this.loadOffers(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}	

  	loadOffers(cb){
  		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.offerHandler.getAllOffers({
			page: this.params.page,
			size: 20,
			term: this.term,
			categories: this.utils.concatenateList(this.categories, "Id", "|"),
			cb:(offers)=>{
				this.hasOffers = (offers.length == 0 && this.params.page == 1) ? false : true;
				this.lastRequestReturnedValues = (offers.length==0) ? false : true;

				this.setupCategories(offers);

				if(this.params.page == 1){
					this.offers = offers;	
				}else{
					for (var i = offers.length - 1; i >= 0; i--) {
						this.offers.push(offers[i]);
					}					
				}

				console.log(this.globals.productCategories)

				this.isLoading = false;

				if(typeof cb == "function")
					cb()			
			}
		})
	}	

	manageOffer($e, offer){
	    this.navCtrl.push(ConsumerOfferManagerPage, {
	      offer: offer
	    });				
	}

	search(ev){
		this.term = ev.target.value;	

		this.loadOffers(null);
	}

	setupCategories(offers){
		for (var i = offers.length - 1; i >= 0; i--) {
			offers[i].ProductCategoryImage = 
				this.utils.returnItemFromList(
					this.globals.productCategories, 
					"Id",
					offers[i].ProductCategoryId
				).Image
		}
	}

	selectCategory(id){
		for (var i = 0; i < this.globals.productCategories.length; ++i) {
			if(this.globals.productCategories[i].Id == id){

				if(this.globals.productCategories[i].IsSelected){
					this.globals.productCategories[i].IsSelected = false;

					this.utils.removeItemFromList(this.categories, "Id", this.globals.productCategories[i]);
				}else{
					this.globals.productCategories[i].IsSelected = true;

					this.utils.pushItemToList(this.categories, this.globals.productCategories[i]);
				}

			}
		}		

		this.params.page = 1;
		
		this.loadOffers(null);
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-offer-list/consumer-offer-list.ts